import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileRecord, FileType } from '../../../../models/ui/file.model';
import { BriefcaseManager } from '../../../../managers/briefcase.manager';
import { Briefcase } from '../../../../models/ui/briefcase.model';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'lex-download-briefcase-dialog',
    templateUrl: './download-briefcase-dialog.component.html',
    styleUrls: ['./download-briefcase-dialog.component.scss'],
    standalone: false
})
export class DownloadBriefcaseDialogComponent implements OnInit {
	public fileList: FileRecord[];
	public briefcase: Briefcase;
	public shouldShowCreateZip: boolean;
	@ViewChild('tooltip', { static: false }) tooltip: MatTooltip;

	constructor(
		private briefcaseManager: BriefcaseManager,
		private dialogRef: MatDialogRef<DownloadBriefcaseDialogComponent, FileRecord | FileType>,
		@Inject(MAT_DIALOG_DATA) data: { files: FileRecord[], briefcase: Briefcase }) {
		this.fileList = data.files;
		this.briefcase = data.briefcase;
		this.shouldShowCreateZip = !(this.fileList.some((x) => x.type === 'outgoing-briefcase-zipped'));
	}

	ngOnInit(): void {
		setTimeout(() => {
			this.tooltip.hide();
		});
	}

	downloadFile(file: FileRecord): void {
		this.briefcaseManager.downloadBriefcaseFile(file).subscribe((response) => {
			window.open(response, '_blank');
			this.dialogRef.close();
		});
	}

	createZip(): void {
		this.briefcaseManager.createBriefcaseFile(this.briefcase.id, 'outgoing-briefcase-zipped').subscribe(() => {
			this.dialogRef.close();
		});
	}

	showCopyMessage() {
		this.tooltip.show();
		setTimeout(() => this.tooltip.hide(), 5000);
	}
}
